module.exports = __webpack_public_path__ + "img/item_part_console_gorilla.2b81a54f.png";